import { render, staticRenderFns } from "./drugintroduce.vue?vue&type=template&id=72b48d47"
import script from "./drugintroduce.vue?vue&type=script&lang=js"
export * from "./drugintroduce.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports